import { ChargeDetailConstant } from "presentation/constant/ChargeDetailMaintenance/ChargeDetailConstant";
import { AdjustmentTypeDroOpts } from "presentation/constant/DropDownOptions/Charge/AdjustmentTypeDroOpts";
import { MessageConstant } from "presentation/constant/MessageConstant";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { useManualChargeDetailVM } from "presentation/hook/ManualCharge/useManualChargeDetailVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useManualChargeDetailTracked } from "presentation/store/ManualCharge/ManualChargeDetailProvider";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useState } from "react";
import { FieldType, HPHButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

export const ManualChargeAdjustmentPanel = () => {
    const [manualChargeDetailState] = useManualChargeDetailTracked();
    const manualChargeDetailVM = useManualChargeDetailVM();
    const { adjustmentEntity, allFormState, selectedManualChargeDetailRows, currentManualChargeHeader } = manualChargeDetailState;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const messageBarVM = useMessageBarVM();

    const handleCancelClick = () => {
        manualChargeDetailVM.handleAdjustmentButtonClick();
    }

    const handleApply = async () => {
        setIsLoading(true);

        try {
            await manualChargeDetailVM.onValidationBeforeAdjustment(adjustmentEntity).then(data => {
                if (data) {
                    manualChargeDetailVM.onAdjustment(selectedManualChargeDetailRows, adjustmentEntity).then(data => {
                        Promise.allSettled([
                            manualChargeDetailVM.onPageInit(currentManualChargeHeader),
                            currentManualChargeHeader.id && manualChargeDetailVM.onSearch(currentManualChargeHeader.id),
                        ]).finally(() => {
                            if (data && data["adjustmentManualChargeFail"]) {
                                messageBarVM.showError(data["adjustmentManualChargeFail"]?.toString());
                            } else {
                                messageBarVM.showSuccess(MessageConstant.common.OPERATION_DONE_SUCCESSFUL.replace(
                                    "{operationDone}", ChargeDetailConstant.Charge.AJDUSTMENT));
                            }

                            setIsLoading(false);
                            manualChargeDetailVM.handleAdjustmentButtonClick();
                            manualChargeDetailVM.onCancelDetail();
                        });
                    }).catch((error) => {
                        setIsLoading(false);
                        manualChargeDetailVM.handleAdjustmentButtonClick();
                    });
                } else {
                    setIsLoading(false);
                }
            })
        } catch (error) {
            setIsLoading(false);
            manualChargeDetailVM.handleAdjustmentButtonClick();
        }
    }

    return (
        <div className='side-form-content-wrapper'>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{ChargeDetailConstant.Charge.AJDUSTMENT}</SidebarTitle>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ height: '75vh', maxHeight: '75vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                            <div className='im-flex-row-item' style={{ width: "180px" }}>
                                <NbisCommonField
                                    errorMessage={allFormState?.["adjustmentType"] ?? ""}
                                    isReadOnly={false}
                                    isShowOptional={false}
                                    readOnlyValue={adjustmentEntity?.adjustmentType ?? ""}
                                    fieldValue={adjustmentEntity?.adjustmentType}
                                    fieldLabel={"Adjustment Type"}
                                    isSaveClicked={false}
                                    fieldType={FieldType.DROPDOWN}
                                    fieldKey={'adjustmentType'}
                                    maxLength={60}
                                    options={AdjustmentTypeDroOpts().getAdjustmentTypeModel().filter(type => (type.tagLabel !== "NORMAL" && type.tagLabel !== "RECAL" && type.tagLabel !== "CANCEL_REBILL_TO_OTHER_COMPANY"))}
                                    requiredFieldList={[]}
                                    onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                                        manualChargeDetailVM.onAdjustmentTypeDropdownChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className='im-charge-data-search-criteria-buttons'>
                {
                    <>
                        <HPHButton label={WorkspaceConstant.Common.BUTTON_CANCEL} size={'Small'} theme={'Secondary'} onClick={handleCancelClick} />
                        <HPHButton label={WorkspaceConstant.Common.BUTTON_UPDATE} size={'Small'} theme={'Primary'} onClick={handleApply} />
                    </>
                }
            </div>
        </div>
    )
}